{
    "defaults": {
        "validation": {
            "scriptElementNotAllowed": "The text contains a <script> element. Please remove it - it cannot be saved while it is there.",
            "scriptUrlNotAllowed": "The text contains a javascript: link. Please remove it - it cannot be saved while it is there."
        },
        "404": "Page not found",
        "title": "Cockpit | Accessory Navigator",
        "confirm": "Confirm",
        "profile": "Profile",
        "logout": "Logout",
        "admin": {
            "contracts": "Contracts",
            "garages": "Garages",
            "products": "Products",
            "productCategories": "Categories"
        },
        "appName": "AN Cockpit",
        "fileTooLarge": "The file is too large. Please select a file smaller than 10 MB.",
        "error": "An error occurred",
        "errorMail": {
            "button": "send e-mail",
            "subject": "error occurred in AN App",
            "href": "support@zubehoer-navigator.de"
        },
        "help": {
            "open": "Open Help Dialog",
            "close": "Close Help Dialog"
        },
        "users": "User Management",
        "cancel": "Abort",
        "errorNotice": "Please try again. If the error persists, please send the following information to our support address:",
        "errorSupport": {
            "whatDone": "What were you doing in the application beforehand?",
            "whichRecord": "Which record was on your screen?",
            "whichStep": "Which step did you want to take when the error occurred?",
            "screenshot": "Feel free to send us a screenshot or a copy of the following message."
        },
        "errorDetails": {
            "title": "Error details",
            "dateTime": "Date/time",
            "trace": "Trace"
        },
        "copyToClipboard": "Copy to clipboard",
        "copied": "Copied to clipboard",
        "goBack": "Go Back to previous page",
        "reload": "Reload the page",
        "close": "Close",
        "confirmDelete": "Are you sure you want to permanently delete this entry?",
        "confirmLeave": "You have unsaved changes. Do you really want to leave?",
        "leaveStay": "Keep editing",
        "leaveConfirm": "Leave",
        "dashboard": "Dashboard",
        "garage": "Garage",
        "groupGarages": "Garages",
        "productCategories": "Categories",
        "products": "Products",
        "orders": "Orders",
        "helpCenter": "Help Center",
        "uploadFile": "Choose file",
        "change": "Change",
        "edit": "Edit Entry",
        "save": "Save Changes",
        "selfManage": "Copy as Own Product",
        "delete": "Delete Entry",
        "add": "Add Entry",
        "details": "Details",
        "userName": "User name",
        "error.required": "Required",
        "coupons": "Discount Codes",
        "crm": {
            "mailer": "Mailer",
            "customer": "Customer Management",
            "opportunities": "Sales Opportunities"
        },
        "emailTemplates": "Mail Design",
        "mailServer": "Mail Delivery",
        "settings": "Settings"
    },
    "crm": {
        "create": "Create New Customer",
        "title": "Customer Details",
        "prospectInformation": "",
        "salutation": "Salutation",
        "salutationOptions": {
            "MALE": "Mr.",
            "FEMALE": "Ms.",
            "NONE": "Other"
        },
        "firstName": "First Name",
        "lastName": "Last Name",
        "name": "Name",
        "referenceNo": "Customer Number",
        "email": "E-Mail",
        "phone": "Phone",
        "vehicleCount": "Vehicles",
        "createdAt": "Created on",
        "consentAccepted": "Consent to be contacted via email has been given",
        "consentSource": "Source of Consent",
        "consentSourceOptions": {
            "NOT_SPECIFIED": "not specified",
            "PURCHASE_AGREEMENT": "purchase agreement",
            "REPAIR_ORDER": "repair order"
        },
        "customerInterests": "Customer Interests",
        "search": "Search customers",
        "overview": {
            "searchButton": "Search",
            "reset": "Reset",
            "filter": {
                "onlyMine": "My customers",
                "unassigned": "Unassigned",
                "brand": "Brand",
                "vehicle": "Vehicle",
                "deliveryDue": "Delivery due soon",
                "lastSendingFailed": "Sending failed",
                "consentMissing": "Consent missing",
                "deliveryUnconfirmed": "Delivery date not confirmed"
            },
            "filterEmpty": {
                "brand": "All brands",
                "vehicle": "All vehicles"
            },
            "filterAll": "All",
            "emptyState": {
                "ONLY_MINE_EMPTY": "No customers are assigned to you. Choose “Unassigned” to see customers without a salesperson."
            },
            "loadError": "The customer list could not be loaded. Please try again or change the filters.",
            "loadErrorReset": "The customer list could not be loaded. Please try again or reset the filters."
        },
        "createSuccess": "Customer created successfully",
        "saveSuccess": "Customer saved successfully",
        "salesperson": {
            "label": "Salesperson",
            "none": "",
            "unknown": "Unknown",
            "readOnlyHint": "The salesperson cannot be changed here.",
            "droppedHint": "The selected salesperson is no longer available. The customer was saved without a salesperson."
        },
        "createError": "Error creating customer",
        "saveError": "Error saving customer",
        "saveChanges": "Save Changes",
        "delete": "Delete Customer",
        "deleteTitle": "Delete Customer",
        "deleteNotice": "Really delete this customer?\n\nThis also deletes all vehicle purchases, campaigns and the mail history.",
        "deleteSuccess": "Customer deleted successfully",
        "deleteError": "Error deleting customer",
        "status": "Status",
        "statusDeleted": "Deleted",
        "deletedOn": "Deleted on {{date}}",
        "mailingStatus": "Campaigns",
        "actionNeed": {
            "column": "Action needed",
            "sendingFailed": "Sending failed",
            "deliveryDue": "Delivery due soon",
            "consentMissing": "Consent missing",
            "dataIncomplete": "Data incomplete",
            "attention": "Action needed",
            "running": "Campaign running",
            "finished": "Finished",
            "noCampaign": "No campaign",
            "inactive": "Inactive"
        },
        "mailingState": {
            "progress": "{{done}} of {{total}} mails",
            "none": "-"
        },
        "campaignsActiveShort": "active",
        "noOpportunitiesWarning": "Warning: no sales opportunities have been activated yet!",
        "campaigns": {
            "title": "Campaigns",
            "loading": "Loading campaigns …",
            "empty": "No campaigns available.",
            "untyped": "Campaign",
            "blocked": "Blocked",
            "noSteps": "No steps available.",
            "step": "Step",
            "plannedFor": "Planned for",
            "sentAt": "Sent on",
            "stepState": "Status",
            "sendFailed": "Failed",
            "types": {
                "VEHICLE_PURCHASE": "Vehicle purchase",
                "BIRTHDATE": "Birthday"
            },
            "states": {
                "INITIAL": "New",
                "RUNNING": "Active",
                "ON_HOLD": "Paused",
                "CANCELED": "Canceled",
                "DEACTIVATED": "Deactivated",
                "FINISHED": "Finished"
            },
            "stepStates": {
                "DATA_INSUFFICIENT": "Data missing",
                "PLANNED": "Planned",
                "EXECUTED": "Sent",
                "SKIPPED": "Skipped",
                "CANCELED": "Canceled",
                "DEACTIVATED": "Deactivated"
            }
        },
        "mailHistory": {
            "title": "Mail history",
            "subject": "Subject",
            "sentAt": "Sent on",
            "state": "Status",
            "loading": "Loading mail history …",
            "empty": "No mail history available.",
            "scheduleHint": "Automatic mail dispatch: {{schedule}}",
            "states": {
                "PREPARED": "Prepared",
                "SEND_SUCCESS": "Sent",
                "SEND_FAILED": "Failed"
            }
        },
        "consent": "Consent",
        "consentGranted": "Granted",
        "consentNotGranted": "Not granted",
        "addVehiclePurchase": "Add Vehicle Purchase",
        "vehiclesAndPurchases": "Vehicles and Purchases",
        "noVehiclesFound": "No vehicles have been added yet.",
        "vehiclePurchase": {
            "title": "Vehicle Purchase",
            "deliveryInformation": "Delivery Status & Dates",
            "selectVehicle": "Select Vehicle",
            "editVehicle": "Edit Vehicle Purchase",
            "contractSignedAt": "Contract Signed At",
            "createdAt": "Created At",
            "deliveredAtEstimated": "Estimated Delivery Month",
            "deliveredAtEstimatedShort": "Delivery Date",
            "deliveredAt": "Handover Date",
            "deliveryEstimated": "estimated",
            "deliveryConfirmed": "confirmed",
            "carline": "Carline",
            "dealership": "Dealership",
            "deleteTitle": "Delete Vehicle Purchase",
            "deleteNotice": "Please confirm that you want to delete the vehicle purchase. This action cannot be undone.",
            "deleteSuccess": "Vehicle purchase deleted successfully",
            "deleteError": "Error deleting vehicle purchase"
        },
        "opportunities": {
            "title": "Sales Opportunities",
            "listTitle": "Opportunities",
            "listHint": "Select an opportunity to view details.",
            "detailsTitle": "Configuration",
            "status": {
                "active": "Active",
                "inactive": "Inactive"
            },
            "emailsSendingNoBrands": "No automated emails will be sent. Please assign marketplaces.",
            "emailsSendingBrands": "Automated emails are sent for the following brands: {{brands}}",
            "templateOnly": "Template",
            "scope": {
                "system": "System template",
                "scoped": "Dealership opportunity"
            },
            "stepsTitle": "E-Mail Phases",
            "stepType": "Contact Point",
            "stepDeadline": "Shipping",
            "stepDeadlineImmediately": "Immediately",
            "stepDeadlineDays": "{{count}} days",
            "stepOrder": "",
            "stepStatus": "Status",
            "stepsCount": "{{count}} e-mails",
            "noSteps": "No steps available.",
            "noOpportunities": "No opportunities available.",
            "selectPrompt": "Select an opportunity to view details.",
            "loadingDetails": "Loading details",
            "sendTrialMail": "send test email",
            "trialMail": {
                "title": "Send test email",
                "description": "Test the email delivery directly to your registered email address. If you select a vehicle, we will automatically add three suitable product suggestions.",
                "email": "send email to",
                "send": "send",
                "sendSuccess": "sent email successfully",
                "sendError": "an error occurred while sending the email",
                "validation": {
                    "vehicle": "select a vehicle, please"
                }
            },
            "types": {
                "VEHICLE_PURCHASE": "Vehicle Purchase",
                "WELCOME_MAIL": "Welcome Mail",
                "ANTICIPATION_MAIL": "Anticipation Mail",
                "FINAL_MAIL": "Final Mail"
            },
            "description": {
                "VEHICLE_PURCHASE": "3-stage email communication after vehicle purchase"
            },
            "vehiclePurchase": {
                "phase": "Phase {{phase}}",
                "welcomeDeadlineImmediately": "Immediately after the vehicle purchase",
                "welcomeDeadlineDays": "{{count}} Days after the vehicle purchase",
                "welcomeContent": "Congratulations on your vehicle purchase! Here are 3 top-selling product recommendations to match your vehicle.",
                "anticipationDeadlineDays": "{{count}} days before vehicle handover",
                "anticipationDeadlineWeeks": "{{count}} weeks before vehicle handover",
                "anticipationContent": "With reference to the upcoming vehicle handover, 3 product recommendations based on the customer's interests and suitable for the vehicle (in later development stages also a coupon)",
                "finalDeadlineDays": "{{count}} days after vehicle handover",
                "finalDeadlineWeeks": "{{count}} weeks after vehicle handover",
                "finalContent": "After the first few weeks, recommendations for products that facilitate the daily use of the vehicle."
            },
            "loadError": "Failed to load opportunities",
            "detailsLoadError": "Failed to load opportunity details",
            "activateSuccess": "Opportunity activated",
            "activateError": "Failed to activate opportunity",
            "deactivateSuccess": "Opportunity deactivated",
            "deactivateError": "Failed to deactivate opportunity"
        },
        "validation": {
            "salutation": {
                "label": "Please select a salutation"
            },
            "firstName": "Please enter a first name",
            "lastName": "Please enter a last name",
            "referenceNo": "Please enter a customer number",
            "emailFormat": "Please enter a valid email address",
            "email": "Please enter an email address",
            "phone": "Please enter a phone number",
            "consentSource": "Please enter a consent source",
            "formHasErrors": "Please correct the errors in the form before saving"
        }
    },
    "garage": {
        "details": {
            "title": "Garage Details"
        },
        "dealerships": {
            "title": "Garage Brands"
        },
        "dpa": {
            "title": "Data Processing Agreement",
            "dialogTitle": "Data processing agreement (DPA) by DSGVO",
            "agreementHeader": "Agreement DPA",
            "agreementInfo1": "You can agree to the data processing agreement in accordance with Section 28 of the General Data Protection Regulation here.",
            "agreementInfo2": "To do so, use the \"Grant digital consent to the AVV\" button in the contract. You can open the contract by clicking on the \"View AVV contract text\" link.",
            "agreementButtonReadOnly": "Show DPA contract text",
            "agreementButton": "Show DPA contract text for signing",
            "agreementHeaderWebsite": "Privacy policy for your website",
            "agreementInfoWebsite": "If you use the Accessory Navigator homepage module on your website, you must add a privacy policy. Please copy and paste the following text into your privacy policy:",
            "agreementInfoWebsiteButton": "Copy text",
            "showEnglishTranslation": "Show the english translation",
            "legalNotice": "Please note: The following contract is only legally binding in its German version. The translation is only for your information and convenience.",
            "mandatoryFields": "Mandatory Garage Fields",
            "companyInfo": "Company Information",
            "noRights": "Note: You do not have the necessary permissions to sign the DPA",
            "noRightsGarage": "Note: You do not have the necessary permissions to edit the company information.",
            "agreement": "Data Processing Agreement",
            "dpaRead": "I have read the DPA",
            "sign": "Agree digitally to DPA",
            "signing": "Submitting agreement...",
            "status": "DPA Status",
            "signed": "Signed",
            "signedInfo": "The data processing agreement was signed at <b>{{signatureDate}}</b> by <b>{{signatory}}</b>",
            "dateFormat": "YYYY-MM-DD, HH:mm",
            "notSigned": "Not signed",
            "notSignedInfo": "Your consent to the General Terms and Conditions has not yet been granted. This is necessary for you to use the Accessory Navigator.",
            "signSuccess": "DPA successfully digitally agreed",
            "signError": "DPA agreement was not successful",
            "withdraw": "revoke DPA",
            "withdrawSuccess": "Revoking the DPA was successful",
            "withdrawError": "Revoking the DPA was failed",
            "confirmWithdraw": "Are you sure that you want to revoke the DPA?",
            "loadingTexts": "is loading...",
            "validation": {
                "missingValues": "Please enter the missing company information",
                "missingValuesOrDirty": "The contract text can only be displayed if the company information is complete and has been saved."
            },
            "readOnlyInSupportContext": "In a support context the data processing agreement is read-only. Only the garage itself can sign or withdraw it."
        }
    },
    "formInformation": {
        "name": "Name",
        "street": "Street",
        "houseNumber": "House No.",
        "country": "Country",
        "postalCode": "Postal code",
        "city": "Town",
        "email": "E-Mail",
        "phoneNumber": "Phone",
        "fax": "Fax",
        "password": "Password",
        "userName": "User Name",
        "delete": "Delete",
        "customerNumber": "Customer-No.",
        "companyName": "Company Name",
        "managingDirector": "Managing Director"
    },
    "userList": {
        "title": "User Management",
        "name": "Name",
        "email": "E-Mail",
        "phone": "Phone",
        "role": "Role",
        "userNo": "User-No.",
        "buttons": {
            "inviteUser": "Invite User"
        },
        "status": {
            "title": "Status",
            "ACTIVE": "Active",
            "INACTIVE": "Inactive",
            "ACTIVATION_PENDING": "Invitation Pending",
            "ACTIVATION_TIMEOUT": "Invitation Expired"
        }
    },
    "userDetail": {
        "title": "User Management",
        "userInformation": "General Information",
        "name": "Name",
        "email": "E-Mail",
        "emailInvalid": "E-Mail is invalid",
        "phone": "Phone",
        "role": "Role",
        "userNo": "User-No.",
        "language": "Language",
        "saveSuccess": "User saved successfully",
        "createSuccess": "User created successfully",
        "deactivateSuccess": "User deactivated successfully",
        "deleteSuccess": "User deleted permanently",
        "activateSuccess": "User activated successfully",
        "isInDebounce": "User activation has just been started. \r\n Please wait a moment to start it again.",
        "error": {
            "saveFailed": "An error occurred while saving the user",
            "createFailed": "An error occurred while creating the user",
            "createFailedDuplicateMail": "Mail address is already in use",
            "deactivateFailed": "An error occurred while deactivating the user",
            "deleteFailed": "An error occurred while deleting the user",
            "activateFailed": "An error occurred while activating the user"
        },
        "buttons": {
            "create": "Create User",
            "saveChanges": "Save Changes",
            "removeUser": "Deactivate User",
            "deleteUser": "Delete user permanently",
            "activateUser": "Activate User",
            "reactivateUser": "Activate User again",
            "revokeInvitation": "Revoke invitation"
        },
        "removeDialog": {
            "title": "Deactivate User",
            "message": "Are you sure you want to deactivate this user? The user will no longer be able to log in.",
            "confirm": "Confirm"
        },
        "deleteDialog": {
            "title": "Delete user permanently",
            "message": "Do you really want to delete {{name}} permanently? The account and its change history will be removed and cannot be restored.",
            "confirm": "Delete permanently"
        },
        "auditTrail": {
            "title": "Change History",
            "action": "Change",
            "timestamp": "Date",
            "user": "User",
            "actions": {
                "CREATE_USER": "user created",
                "INVITE_USER": "user invited via email",
                "RESET_PASSWORD": "reset password",
                "SET_PWD_AND_ACTIVATE": "set password and activated",
                "DEACTIVATE_USER": "user deactivated",
                "ACTIVATE_USER": "user activated",
                "PERMISSION_ASSIGNED": "permission assigned",
                "PERMISSION_REVOKED": "permission revoked",
                "ROLE_ASSIGNED": "role assigned",
                "MODIFY_SALUTATION": "salutation modified",
                "MODIFY_NAME": "name modified",
                "MODIFY_EMAIL": "email modified",
                "MODIFY_LANGUAGE": "language modified",
                "MODIFY_PHONE": "phone number modified",
                "GROUP_SCOPE_ASSIGNED": "garage group scope assigned",
                "GARAGE_SCOPE_ASSIGNED": "garage scope assigned",
                "DISTRIBUTOR_SCOPE_ASSIGNED": "distributor scope assigned"
            }
        }
    },
    "myGarage": {
        "garageDetails": {
            "title": "Dealership Data",
            "garage": "Dealership",
            "registry": "Registry Court",
            "addressAndContact": "Address & Contact",
            "configuration": "Mail Configuration",
            "senderName": "Sender Name",
            "senderEmail": "Sender-E-Mail-Address",
            "host": "Host",
            "port": "port",
            "ssl": "SSL/TLS",
            "smtpInformation": "Log-In details SMTP",
            "serverInformation": "Server details",
            "userInformation": "User details",
            "standardPort": "Standard Port",
            "saveSuccess": "Garage data saved successfully",
            "saveError": "An error occurred while saving the garage data",
            "euShop": "Sale of goods must comply with EU law",
            "euShopYes": "Yes",
            "euShopNo": "No",
            "euShopTooltip": "If you sell to customers in an EU country, the sale must comply with applicable EU law. The shop then displays the EU guarantee labels, among other things."
        },
        "account": {
            "group": "Group",
            "noGroup": "no group",
            "openGroup": "Open group"
        },
        "location": {
            "title": "Sales",
            "dataLocation": "Garage Geo-Location",
            "latitude": "Latitude",
            "longitude": "Longitude",
            "countries": "Sales countries",
            "viewDealershipLocation": "Image of garage for search results",
            "picFormat": "Please select only image files in .jpg format. The file should not exceed a size of 1 MB (approximately 800 × 500 pixels).",
            "chooseFile": "Choose file"
        },
        "contract": {
            "status": "Data Processing Agreement",
            "agreement": "DPA accepted",
            "date": "Date",
            "signed": "Signature"
        },
        "dealership": {
            "title": "Garage Brands",
            "editDetails": "Edit Details",
            "dealerNumber": "Dealer No.",
            "dealerData": "Dealer Data",
            "hourlyRateTitle": "Hourly Billing Rate",
            "hourlyRateNotice": "Hourly billing rate (incl. VAT)\n1 hour = 10 work units",
            "configNonExistent": "The shop configuration data is not available.",
            "dealerAliasNo": "Alternative Dealer No.",
            "inVacation": "Exclude this dealer from all search results",
            "imprintLink": "Link to legal information / imprint",
            "dataPrivacyLink": "Link to privacy / data protection notice",
            "modify": {
                "success": "Brand successfully saved",
                "error": "Saving brand was not successful"
            },
            "noDealerships": "No dealers have yet been added for this garage.",
            "notFound": "Brand could not be loaded",
            "legalTexts": {
                "title": "Legal texts",
                "agbTitle": "Terms and Conditions",
                "widerrufTitle": "Right of Withdrawal",
                "widerrufLinkLabel": "Link to the cancellation policy",
                "widerrufLinkNotice": "If a link is set, the shop only shows the link – the maintained cancellation text is kept but not used.",
                "widerrufTextNotice": "Without a link, the cancellation text maintained here is shown in the shop.",
                "saveError": "Error saving legal texts",
                "modeText": "Maintain text",
                "modeLink": "Use link",
                "imprintTitle": "Imprint",
                "privacyTitle": "Privacy policy",
                "imprintLinkNotice": "With a link the shop shows only the link; the maintained text stays stored.",
                "imprintTextNotice": "Without a link the shop shows this text, followed by IT-Tecture's imprint as operator.",
                "privacyLinkNotice": "With a link the shop shows only the link, also in the enquiry and share forms; the maintained text stays stored.",
                "privacyTextNotice": "Without a link the shop shows this text. If it is empty, the default privacy policy of the Accessory Navigator appears."
            }
        }
    },
    "garages": {
        "pagination": {
            "total": "Total garages",
            "pages": "Number of pages",
            "showNumberOfDealer": "Number of garages per page"
        },
        "company": "Company",
        "dealer": "Dealership"
    },
    "productCategory": {
        "section": "Category Details",
        "name": "Name",
        "subTitle": "Subtitle",
        "language": "Language",
        "position": "Order",
        "actions": "Actions",
        "image": "Image",
        "imageChange": "Change Image"
    },
    "productCategories": {
        "buttons": {
            "addCategory": "Add Category",
            "editCategory": "Edit Category",
            "deleteCategory": "Delete Category",
            "changeSortOrder": "Save sort order"
        },
        "help": {
            "title": "Help for Product Category Management",
            "sectionTitle": "Product Categories",
            "sectionDescription": "Here you can create and manage your own product categories. These categories can later be used for your products independently of the catalogs. They will be displayed in the homepage module either before or after the catalog categories."
        },
        "createCategory": "Create own category",
        "image": "Image",
        "name": "Name",
        "subTitle": "Subtitle",
        "language": "Language",
        "position": "Order",
        "actions": "Actions",
        "noCategoriesYetMsg": "No product categories have been created yet",
        "catalogCategoriesDivider": "Catalog categories are displayed here",
        "validation": {
            "name": "Please enter a name",
            "language": "Please select a language"
        },
        "sortOrderSaved": "Sort order saved successfully",
        "sortOrderSaveError": "An error occurred while saving the sort order",
        "saveSuccess": "Category saved successfully",
        "saveError": "An error occurred while saving the category",
        "deleteSuccess": "Category deleted successfully",
        "deleteError": "An error occurred while deleting the category"
    },
    "product": {
        "priceHistory": {
            "chart": {
                "price": "Price",
                "rrp": "MSRP"
            },
            "title": "Price History",
            "date": "Date",
            "loading": "Loading price history...",
            "price": "Price",
            "status": "Status",
            "valid": "Valid",
            "invalid": "Invalid",
            "actions": "Actions",
            "noValidEntries": "No valid entries available",
            "noProductNo": "No product number provided",
            "markInvalid": {
                "title": "Enter reason for change",
                "description": "You want to make changes to the price validity. Please provide the reason.",
                "warningTitle": "Note EU OMNIBUS DIRECTIVE",
                "warningText": "Changes to price validity should only be made if you have a valid reason. Unjustified changes may have legal consequences.",
                "reason": "Reason for invalidity",
                "reasonPlaceholder": "e.g. Price error",
                "confirm": "Mark as invalid",
                "cancel": "Cancel"
            }
        },
        "productDetails": {
            "createProduct": "Create own product",
            "title": "Product Details",
            "success": "Product saved successfully",
            "error": "An error occurred while saving the product",
            "delete": "Delete product",
            "confirmDelete": "Are you sure you want to permanently delete this product?",
            "deleteSuccess": "Product saved successfully",
            "deleteError": "An error occurred while deleting the product",
            "media": {
                "title": "Images",
                "dropzoneHint": "Drag and drop files here or click to upload.<br/><br/>Resolution: max. 3000 × 2000 pixel<br/>Files Size: max. 10 MB<br/>Supported Formats: jpg, png, webp",
                "dropHere": "Drop files here",
                "images": {
                    "title": "Product Images",
                    "currentFavorite": "current gallery image",
                    "add": {
                        "title": "Add Image"
                    },
                    "actions": {
                        "favorite": "make gallery image",
                        "unfavorite": "remove gallery image"
                    }
                },
                "videos": {
                    "url": "Url",
                    "preview": "Preview (image)",
                    "title": "Videos",
                    "titleNew": "Add video"
                },
                "validation": {
                    "media": "Please select an image"
                }
            },
            "general": {
                "title": "General Information",
                "name": "Name",
                "partNos": "Partnumbers",
                "category": "Categories",
                "referenceNumber": "Reference number",
                "validationErrors": {
                    "REFERENCE_NO_MISSING": "Reference number missing",
                    "PRODUCT_PRICE_MISSING": "Price missing",
                    "PRODUCT_TITLE_MISSING": "Product name missing",
                    "PRODUCT_DESCRIPTION_MISSING": "Product description missing",
                    "PRODUCT_NATURE_MISSING": "Product type missing",
                    "PRODUCT_IMAGE_MISSING": "Product image missing",
                    "PRODUCT_CATEGORY_MISSING": "Category missing",
                    "PRODUCT_CATEGORY_INVALID": "Category invalid",
                    "PRODUCT_PARTS_MISSING": "Part number missing",
                    "PRODUCT_PLATFORM_DEPENDENCY_INVALID": "Invalid platform dependency",
                    "PRODUCT_CARLINE_INVALID": "Invalid carline",
                    "PRODUCT_PUBLISHING_REJECTED": "Product publishing rejected"
                },
                "fieldErrors": {
                    "DUPLICATE_REF_NO": "Reference number must be unique within a catalog"
                },
                "nature": {
                    "label": "Type of product",
                    "ACCESSORY": "Accessory",
                    "LIFESTYLE": "Lifestyle",
                    "WHEEL": "Wheels & tyres",
                    "SOFTWARE": "Software"
                },
                "condition": {
                    "label": "Item condition",
                    "NEW": "New",
                    "REFURBISHED": "Refurbished",
                    "USED": "Used"
                },
                "language": {
                    "label": "Language",
                    "de": "German",
                    "en": "English",
                    "fr": "French",
                    "sv": "Swedish"
                },
                "validation": {
                    "longDescription": "Please enter a description"
                }
            },
            "contentSize": {
                "title": "Content Size for Base Price Calculation",
                "required": "Base Price must be stated for this product",
                "unit": "Unit",
                "value": "Quantity",
                "unitTypes": {
                    "METRE": "m",
                    "MILLI_METRE": "mm",
                    "LITRE": "l",
                    "MILLI_LITRE": "ml",
                    "KILO_GRAM": "kg",
                    "GRAM": "g",
                    "SQUARE_METRE": "m²",
                    "SQUARE_MILLI_METRE": "mm²",
                    "CUBIC_METRE": "m³",
                    "CUBIC_MILLI_METRE": "mm³"
                }
            },
            "selectRelevantDistributors": "Select relevant brands",
            "errorSelectAtLeastOneDistributor": "At least one brand must be selected",
            "ownCatalogLabel": "Own Catalog",
            "selectCatalogSource": "Select Catalog Source",
            "selectCategoryFromSource": "Select Category from Source",
            "errorSelectCategory": "Please select a category",
            "noCategoriesInSelectedSource": "No categories available in the selected source",
            "noCarlinesAvailable": "No carlines available",
            "errorSelectedCategoryDeprecated": "The selected category is no longer available. Please select another category.",
            "errorSelectedCarlinesDeprecated": "Some assigned vehicles are no longer available. Please remove them from the selection.",
            "removeDeprecatedCarlines": "Remove unavailable assignments",
            "deprecatedBadge": "no longer available",
            "deprecatedTooltip": "This entry is no longer available and cannot be newly assigned. Please remove the assignment.",
            "errorSelectSource": "Please select a catalog source",
            "carlineSystem": "Carline System",
            "dealerSection": "Assign to Catalogue",
            "fitments": "Fitments",
            "description": "Description",
            "priceHistory": {
                "title": "Price History (EU Omnibus Directive)",
                "description": "Overview of price changes over the last 30 days in accordance with the EU Omnibus Directive",
                "loading": "Price history is loading...",
                "noEntries": "No price changes found in the last 30 days",
                "date": "Date",
                "previousPrice": "Previous Price",
                "newPrice": "New Price",
                "status": "Status",
                "actions": "Actions",
                "valid": "Valid",
                "invalid": "Invalid",
                "markInvalid": {
                    "title": "Mark entry as invalid",
                    "description": "Enter a reason why this price entry should be marked as invalid:",
                    "reason": "Reason for invalidity",
                    "confirm": "Mark as invalid"
                }
            },
            "gpsr": {
                "title": "General Product Safety Regulation (GPSR)",
                "general": {
                    "title": "General Information",
                    "make": "Brand"
                },
                "common": {
                    "recipient": "Recipient",
                    "recipientLine2": "Recipient (Line 2)",
                    "street": "Street",
                    "streetLine2": "Street (Line 2)",
                    "postCode": "Zip Code",
                    "city": "City",
                    "state": "State",
                    "country": "Country",
                    "email": "Email",
                    "website": "Website",
                    "phone": "Phone"
                },
                "producer": {
                    "title": "Producer"
                },
                "representative": {
                    "title": "Representative"
                },
                "errorProducer": "The data for producer are incomplete (at least Recipient, Street, Zip Code, City)",
                "errorRepresentative": "The data for representative are incomplete (at least Recipient, Street, Zip Code, City)"
            },
            "manufacturerWarranty": {
                "title": "Manufacturer warranty",
                "sectionTitle": "Warranty details",
                "modelIdentifier": "Model identifier",
                "durationYears": "Warranty duration (years)",
                "error": "Please provide both the model identifier and the warranty duration, or leave both fields empty"
            },
            "price": {
                "retailPrice": "Retail Price",
                "vatRate": "VAT",
                "title": "Price",
                "rrp": "MSRP",
                "fixedPrice": "Own Price",
                "percentageFromRrp": "Adjustment in %",
                "lowestPrice30Days": "Lowest price of the last 30 days",
                "specialOffer": "Will be shown as a special offer",
                "noSpecialOffer": "No special offer",
                "copyRrpNoOfferHint": "With the \"MSRP\" price rule a special offer is not possible",
                "validation": {
                    "retailPriceValue": "Please enter the retail price",
                    "vatRate": "Please enter the value added tax"
                }
            },
            "options": {
                "title": "Product Settings"
            },
            "shipping": {
                "title": "Sell Options",
                "shipping": "Shipping",
                "shippingCosts": "Shipping cost",
                "shippingCostsZero": "Free shipping",
                "pickup": "Pickup",
                "mounting": "Mounting",
                "mountingLabourValue": "Labour Value",
                "workUnit": "LV",
                "noCatalogueValue": "Catalogue value not available",
                "isCatalogueValue": "Already set to catalogue value",
                "resetToCatalogue": "Reset to catalogue value",
                "catalogueMountingLabourValue": "Catalogue Mounting Labour Value",
                "catalogueMountingCost": "Catalogue Mounting Cost",
                "pricingOverview": {
                    "title": "Pricing Overview:",
                    "productPrice": "Product Price:",
                    "mountingCosts": "Mounting Costs:",
                    "priceInclMounting": "Price incl. Mounting:",
                    "shippingCosts": "Shipping Costs:",
                    "priceInclShipping": "Price incl. Shipping:"
                },
                "validation": {
                    "options": "Please select an option"
                }
            },
            "receivability": {
                "title": "Receivability",
                "IMMEDIATELY": "Immediately (within 24h)",
                "STANDARD": "Standard (1-2 working days)",
                "SHORT_TERM": "Short Term (3-5 working days)",
                "MID_TERM": "Mid Term (5-8 working days)",
                "LONG_TERM": "Long Term (more than 10 working days)"
            },
            "singleItem": {
                "label": "Single item – only 1 available",
                "explanation": "Enable this option if you own only a single unit of this item.",
                "warning": "Note: Once this item has been sold it is no longer available and will be removed from all marketplaces. You can reactivate the item later on this page."
            },
            "deactivatedHint": "This product is currently not listed, no marketplace has been selected. If you wish to list the product again, select a marketplace at the bottom of the page.",
            "platforms": {
                "title": "Platforms",
                "HPM": "Accessory Navigator",
                "GOOGLE_SHOPPING": "Google Shopping",
                "AMAZON": "Amazon",
                "EBAY": "eBay",
                "UNKNOWN": "unknown",
                "googleShoppingDisclaimer": "Please note: Google Shopping can only be activated if the product can be shipped and has already been activated in the accessory navigator.",
                "locked": {
                    "notConfigured": "Not set up for this dealer.",
                    "requiresShippingAndHpm": "Only available with shipping and an active Accessory Navigator."
                },
                "validation": {
                    "platforms": "Please select at least one platform"
                }
            },
            "interests": {
                "title": "Customer Interests",
                "explanation": "Customer might have the following interests when buying this product:",
                "notice": "The interests were determined by the Accessory Navigator AI and may not be accurate at the moment.",
                "noneAvailable": "No customer interests have been specified yet. They will be automatically generated from the provided texts. This may take some time and might not produce any results.",
                "BICYCLE": "Cyclist",
                "CHILDREN": "Children",
                "COMMUTER": "Commuter",
                "DOG_OWNER": "Dog Owner",
                "DONKEY": "Car as a Workhorse",
                "ELECTRIC_VEHICLE": "Electric Vehicle Accessories",
                "OUTDOOR": "Outdoor",
                "WINTER": "Winter Accessories",
                "SUMMER": "Summer Accessories",
                "WINTERSPORT": "Wintersports"
            },
            "selfManage": {
                "success": "Successfully created own product.",
                "error": "Error during creation of own product.",
                "dialogTitle": "Copy to Own Products?",
                "dialogDescription": "This will copy the product, and create an Own Product from it.\nAll details will be copied, and the Own Product will be activated on the marketplaces.\nAfter copying, the market places will be deactivated on the original product.\nWhen done, you will be redirected to the overview of your Own Products.",
                "confirm": "Copy to Own Products"
            }
        },
        "errorNoCatalogs": "No catalogs published or no main dealership assigned"
    },
    "productOverview": {
        "garageSelector": "Dealer selection",
        "catalogSelector": "Catalog selection",
        "catalogSelectorPlaceholder": "Catalog selection",
        "customCatalog": "Own Products",
        "filterApply": "Apply Filter",
        "buttons": {
            "manageCategories": "Manage Categories",
            "addProduct": "Add Product",
            "massUpdate": "Edit Filtered Products",
            "republish": "Republish"
        },
        "pagination": {
            "total": "Total products",
            "pages": "Number of pages",
            "showNumberOfProducts": "Number of products per page"
        },
        "product": "Product",
        "image": "Image",
        "manufacturer": "Manufacturer",
        "partNos": "Part No.",
        "label": "Name",
        "categories": "Categories",
        "fitment": "Fitment",
        "retailPrice": "MSRP",
        "purchasePrice": "Material Price",
        "labour": "Labour",
        "shipping": "Shipping",
        "pickup": "Pickup",
        "mounting": "Mounting",
        "platforms": "Marketplaces",
        "noGarage": "No Garage or Garage Group selected. Please select a garage to view products.",
        "republishDialog": {
            "title": "Republish products",
            "message_one": "The product of the current filter will be sent to its marketplaces again. This may take a few minutes.",
            "message_other": "All {{count}} products of the current filter will be sent to their marketplaces again. This may take a few minutes.",
            "confirm": "Republish"
        },
        "republishStarted": "The products are being republished",
        "republishFailed": "The products could not be republished"
    },
    "productMassUpdate": {
        "title": "Edit selected products",
        "sectionTitle": "Changes",
        "filter": {
            "title": "Filter Criteria",
            "catalogLabel": "Catalog",
            "productCountWarning": "Update will be applied to {{productCount}} products!"
        },
        "prices": {
            "title": "Update prices",
            "label": "",
            "percentFromRRP": "based on MSRP",
            "options": {
                "NO_CHANGES": "no changes",
                "USE_RRP": "use recommended retail price (MSRP)",
                "PRICE_CHANGE_PERCENTAGE": "Adjust by percentage"
            }
        },
        "sellingOptions": {
            "title": "Sales Options",
            "pickup": {
                "title": "Pickup",
                "options": {
                    "NO_CHANGES": "no changes",
                    "AVAILABLE": "available",
                    "UNAVAILABLE": "unavailable"
                }
            },
            "shipping": {
                "title": "Shipping",
                "changeCosts": "Change Shipping & Handling",
                "shippingCostsZero": "Free Shipping",
                "options": {
                    "NO_CHANGES": "no changes",
                    "AVAILABLE": "available",
                    "UNAVAILABLE": "unavailable"
                }
            },
            "mounting": {
                "title": "Fitting",
                "mountingLabourValurPrefix": "LV",
                "options": {
                    "NO_CHANGES": "no changes",
                    "AVAILABLE": "available",
                    "UNAVAILABLE": "unavailable"
                },
                "labourValue": {
                    "label": "Individual LV",
                    "options": {
                        "NO_CHANGES": "no changes",
                        "SET": "set",
                        "REMOVE": "remove"
                    }
                }
            }
        },
        "availability": {
            "title": "Availability",
            "options": {
                "IMMEDIATELY": "Immediately (within 24h)",
                "STANDARD": "Standard (1-2 working days)",
                "SHORT_TERM": "Short Term (3-5 working days)",
                "MID_TERM": "Mid Term (5-8 working days)",
                "LONG_TERM": "Long Term (more than 10 working days)",
                "NO_CHANGES": "no changes"
            }
        },
        "platforms": {
            "title": "De-/Activate on Marketplaces",
            "options": {
                "NO_CHANGES": "no changes",
                "DEACTIVATE": "deactivate",
                "ACTIVATE": "activate"
            }
        },
        "buttons": {
            "save": "apply changes"
        },
        "saveSuccess": "Changes successfully submitted",
        "saveFailure": "Submitting changes failed"
    },
    "login": {
        "registerButton": "Continue to Login",
        "appName": "ZN-Cockpit",
        "subTitle": "Administrative workplace for accessories in the AfterSales business",
        "news": {
            "items": [
                {
                    "title": "Welcome to our new administration interface",
                    "description": "May we introduce: Our new 'Cockpit'.\nOur entire team has put in a lot of effort to make working with the Accessory Navigator even easier for you. Your login details will, of course, remain the same. Log in and test your new Cockpit. We appreciate any feedback on the new Cockpit, either by phone or email at: <a href=\"tel:+49381666989100\">+49 381 666 989 100</a> or <a href=\"mailto:support@zubehoer-navigator.de\">support@zubehoer-navigator.de</a>"
                },
                {
                    "title": "80% of accessory sales are generated in connection with vehicle sales.",
                    "description": "… unfortunately, this potential is still far too underutilized in car dealerships. We want to change that!\nWith the accessory communicator for new and used cars, you now have access to a new feature that allows you to specifically address your vehicle customers on the topic of accessories. This way, you can reach your customers at the peak of their interest."
                },
                {
                    "title": "Use vehicle handover to sell accessories",
                    "description": "Increase your accessory sales with customized coupons tailored to your brand. We take care of printing and shipping. You benefit from higher sales and stronger customer loyalty."
                }
            ],
            "footerText": "Not yet a customer of the Accessory Navigator? You can find all the information on ",
            "footerLinkText": "our website"
        },
        "copyright": "IT-Tecture. All rights reserved."
    },
    "contracts": {
        "contracts": "Contracts",
        "createContract": "Offer has been generated!",
        "close": "Close",
        "openContract": "copy contract link",
        "customerDetail": {
            "title": "Customer Data",
            "submit": "Submit",
            "opportunity": "Opportunity",
            "opportunityId": "Opportunity ID",
            "contact": {
                "contactData": "Contact data",
                "accountName": "Dealersip-Name",
                "email": "Email",
                "telephone": "Phone",
                "mobile": "Mobile",
                "name": "Name",
                "city": "City",
                "postalCode": "Postcode",
                "street": "Street",
                "country": "Country",
                "address": "Address"
            }
        },
        "tariffCalculation": {
            "totalPrice": "Total Price",
            "calculateButton": "Calculate",
            "createOffer": "Generate Offer",
            "title": "Tariff Calculation",
            "tariffBoxTitle": "Tariff & Term",
            "product": "Tariff",
            "project": "Price Book",
            "projectError": "Select Tariff!",
            "productError": "Select Price Book!",
            "brandError": "Amount missing!",
            "locationError": "Amount missing!",
            "opportunityError": "Opportunity incomplete or not found!",
            "number": "Number",
            "location": "Location",
            "perLocations": "per Location",
            "selectPlaceholder": "Select Brands",
            "duration": "Duration",
            "selectError": "Select Brand",
            "durationError": "Select Duration",
            "expiryDateError": "Select Expiry Date",
            "monthlyCostSection": {
                "title": "Monthly Costs",
                "brands": "No. of Brands",
                "groupModule": "Group Module",
                "uclLicense": "Used Car Module",
                "baseCost": "Base Cost (inkl. one brand)",
                "location": "No. of Locations",
                "uclLicensePerLocation": "Used Car Module per Location",
                "groupModulePerLocation": "Group Module per Location",
                "brandSurchargePerLocation": "Brand Surcharge (per additional brand)"
            },
            "setUpCostSection": {
                "title": "Setup Costs"
            },
            "types": {
                "tablet": "No. Tablets",
                "tabletTerminal": "No. Stands for Tablet",
                "qrCodeSets": "QR Magnet Tag (sets)",
                "qrCodeHanger": "QR Mirror Hanger",
                "qrStickerRoll": "QR Sticker Roll",
                "expiryDate": "Expiry date",
                "monthlyDiscount": "Monthly Discount",
                "discount": "Onetime Discount"
            },
            "additionalConditions": "Special contractual conditions"
        },
        "contractList": {
            "accountName": "Account Name",
            "offerNumber": "Offer No.",
            "status": "Status",
            "contractManager": "Created by",
            "date": "Date",
            "offerLink": "URL for Customer",
            "addContract": "Add Contract",
            "created": "New",
            "draft": "Draft",
            "signed": "Signed",
            "deleted": "Deleted",
            "expired": "Expired",
            "submitted": "Published",
            "canceled": "Canceled",
            "gone": "Closed",
            "copyLink": "Copy Link",
            "tooltipCopyLink": "link copied",
            "cancelSuccess": "Contract has been canceled"
        }
    },
    "garageList": {
        "details": {
            "toggle": "Show/hide details",
            "customerNumber": "Customer no.",
            "accountsReceivableNo": "Accounts receivable no.",
            "address": "Address",
            "group": "Group",
            "email": "E-mail",
            "phone": "Phone"
        },
        "title": "Car dealerships",
        "customerNumber": "Customer-Nr.",
        "garageName": "Company/Business",
        "postalCode": "Postal code",
        "city": "City",
        "country": "Country",
        "nsc": "NSC",
        "customerActive": "Active Customer",
        "noActivity": "No activity for 30 days",
        "noAgreement": "no DPA",
        "addGarage": "Add Garage",
        "removeGarage": "Remove garage",
        "garageListFilter": {
            "title": "Filter",
            "placeholder": "find garages by name, customer no, address",
            "country": "Countries",
            "brand": "Brands",
            "nsc": "NSC",
            "searchButton": "Search",
            "resetButton": "Clear all filters"
        },
        "buttons": {
            "dpaMassUpdate": "Sign DPAs"
        },
        "dpa": {
            "title": "Sign DPAs",
            "agreeFirstInfo": "Before you continue your work, please agree to the missing DPAs by clicking \"Sign DPAs\"",
            "signGarages": "Attention: hereby you sign DPA for the following garages:",
            "garagesMissingData": "The following garages are missing required information for the DPA:",
            "signSuccess": "DPAs successfully digitally agreed",
            "signError": "DPAs agreement was not successful",
            "buttons": {
                "agreeAll": "Sign open DPAs",
                "agreeValid": "Sign valid DPAs"
            }
        }
    },
    "user": {
        "title": "Account management",
        "account": {
            "title": "My Account",
            "personalData": "Personal Data",
            "salutation": {
                "label": "Salutation:",
                "MALE": "Mr.",
                "FEMALE": "Ms.",
                "NONE": "other"
            },
            "email": "E-Mail",
            "name": "Name",
            "phone": "Phone",
            "language": "Language",
            "success": "Changes saved successfully",
            "error": "An error occurred while saving the changes",
            "appearance": {
                "title": "Appearance",
                "description": "Choose the color scheme for the interface.",
                "system": "System default",
                "light": "Light",
                "dark": "Dark"
            }
        },
        "password": {
            "title": "Password",
            "change": "Change Password",
            "oldPassword": "Old Password",
            "newPassword": "New Password",
            "newPasswordConfirm": "Confirm Password",
            "success": "Password changed successfully",
            "error": "An error occurred while changing the password",
            "mismatch": "The new passwords do not match",
            "tooShort": "The password is too short"
        }
    },
    "filter": {
        "chooseFilter": "Choose filter",
        "chooseOperator": "Choose operator",
        "enterValue": "Enter value",
        "chooseValue": "Choose value",
        "keys": {
            "PLATFORM_NO": "Marketplace",
            "PRODUCTNAME": "Product name",
            "PART_NO": "Part number",
            "REFERENCE_NUMBER": "Reference number",
            "PRICE": "Price",
            "RRP": "MSRP",
            "DISTRIBUTION_PICKUP": "Pickup",
            "DISTRIBUTION_SHIPPING": "Shipping",
            "DISTRIBUTION_MOUNTING": "Mounting",
            "RRP_PRICE_PARITY": "Price equals MSRP",
            "CUSTOM_LABOUR_VALUE": "Custom labour value",
            "CATALOG_LABOUR_VALUE": "Catalog labour value",
            "CARLINE_NO": "Carline",
            "CATEGORY_NO": "Category"
        },
        "operator": {
            "IS": "= equals",
            "LIKE": "% contains",
            "GTE": ">= at least ",
            "LTE": "<= at most ",
            "EMPTY": "missing",
            "IN": "available in",
            "NIN": "not available in"
        },
        "operatorLong": {
            "IS": "=",
            "LIKE": "contains",
            "GTE": "≥",
            "LTE": "≤",
            "EMPTY": "missing",
            "IN": "=",
            "NIN": "≠"
        },
        "values": {
            "": "",
            "true": "Yes",
            "false": "No",
            "hpm-guid": "Accessory Navigator",
            "google-shopping-guid": "Google Shopping"
        }
    },
    "order": {
        "errorNoOrderNo": "No order number provided"
    },
    "orders": {
        "referenceNumber": "Reference Number",
        "search": "Search by order number, dealer number or customer email",
        "createAfter": "Show Orders Since (Date)",
        "filterApply": "Apply Filter",
        "filterReset": "Reset Filter",
        "export": "Export as XLSX",
        "orderDate": "Order Date",
        "garage": "Garage",
        "shippingOptions": "Shipping Options",
        "totalAmount": "Total Amount",
        "status": "Status",
        "items": "Items",
        "orderState": {
            "placed": "Cart placed",
            "approved": "Approved",
            "authorized": "Authorized",
            "confirmed": "Ordered",
            "debited": "Debited",
            "closed": "Closed",
            "paymentFailed": "Payment failed",
            "paymentReset": "Payment reset",
            "accepted": "Accepted",
            "revoked": "Revoked",
            "canceled": "Canceled"
        },
        "paymentFailedNotice": "Payment processing failed after checkout.",
        "paymentFailedDescription": "Attention: The customer completed the checkout process successfully from their perspective. However, an error occurred during the subsequent payment processing.",
        "revokedNotice": "Order was revoked by the customer.",
        "title": "Order Details",
        "orderInformation": "Order Information",
        "administration": "Administration",
        "itemOverview": "Item Overview",
        "paymentProvider": "Payment Provider",
        "paymentProviders": {
            "unset": "Not set",
            "paypal": "PayPal",
            "paypal-express": "PayPal Express",
            "paypal-capture": "PayPal Capture",
            "cash": "Cash on Pickup",
            "psa-payment-solution": "PSA Payment Solution",
            "psa-sale-ov": "PSA Sale OV",
            "prepaid": "Prepaid",
            "stripe": "Stripe",
            "gratis": "Free of charge"
        },
        "customerContact": "Customer Contact",
        "vehicle": "Vehicle",
        "customerName": "Customer Name",
        "customerMail": "Customer E-Mail",
        "customerPhone": "Customer Phone",
        "address": {
            "billing": "Billing Address",
            "shipping": "Shipping Address",
            "pickup": "Pickup Location"
        },
        "licensePlate": "License Plate",
        "vin": "VIN",
        "garageName": "Garage Name",
        "comment": "Customer Comment",
        "controlNote": "Internal Note",
        "itemName": "Item Name",
        "itemQuantity": "Item Quantity",
        "itemPrice": "Item Price",
        "itemMountingCosts": "Assembly",
        "itemTotalPrice": "Item Total Price",
        "productNo": "Product No.",
        "subTotal": "Subtotal",
        "coupon": "discount code",
        "shippingCosts": "Shipping Costs",
        "plusShipping": "Plus shipping",
        "mountingCostsSum": "Assembly costs",
        "segmentTotal": "Segment Total",
        "grandTotal": "Grand Total",
        "segmentType": {
            "pickup": "Pickup",
            "shipping": "Shipping",
            "mounting": "Mounting"
        },
        "saveChanges": "Save Changes",
        "saveSuccess": "Changes saved successfully",
        "saveError": "An error occurred while saving the changes",
        "cancelOrder": "Cancel Order",
        "cancelSuccess": "Order canceled successfully",
        "cancelError": "An error occurred while canceling the order",
        "cancelConfirm": {
            "title": "Cancel order?",
            "message": "Do you really want to cancel this order? This action is final and cannot be undone.\n\nNote: The customer will not be notified automatically. Please inform them separately if needed.",
            "confirm": "Cancel order now"
        },
        "revocation": {
            "title": "Information on Cancellation as of {{revocationDate}}",
            "name": "Customer Name",
            "email": "Customer E-Mail",
            "reason": "Revocation Reason"
        }
    },
    "unit": {
        "piece": "piece"
    },
    "language": {
        "de": "German",
        "en": "English"
    },
    "coupons": {
        "title": "Discount code Details",
        "create": "Create discount code",
        "search": "Search coupons",
        "filterApply": "Apply Filter",
        "filterReset": "Reset Filter",
        "couponNo": "Discount code No.",
        "description": "Description",
        "code": "Code",
        "type": "Type",
        "discount": "Discount",
        "usedContingent": "Used / Total",
        "activeLabel": "Active",
        "contingentLimitation": "Usage Limit",
        "contingentLimitationHelp": "0 = unlimited usage",
        "validFrom": "Valid From",
        "validUntil": "Valid Until",
        "minimumOrderAmount": "Minimum Order Amount",
        "excludeDiscounted": "Discounted items are excluded from this coupon",
        "couponInformation": "Discount code Information",
        "usageInformation": "Usage Information",
        "noValidUntil": "No valid until date",
        "noMinimumOrderAmount": "No minimum order amount",
        "noUsageInfoForNewCoupon": "Usage information will be available after the coupon is created.",
        "saveChanges": "Save Changes",
        "createSuccess": "Discount code created successfully",
        "saveSuccess": "Discount code saved successfully",
        "noShopHint": "You do not have an active shop yet, so you cannot create discount codes. Please contact us if you are interested in a shop.",
        "createError": "Error creating coupon",
        "saveError": "Error saving coupon",
        "validation": {
            "description": "Please enter a description",
            "code": "Please enter a code",
            "type": "Please select a type",
            "discountValue": "Please enter a discount value",
            "contingentLimitation": "Please enter a contingent limitation",
            "validFrom": "Please select a valid from date",
            "minimumOrderAmount": "Please enter a minimum order amount",
            "discountValuePositive": "Please enter a positive discount value",
            "contingentLimitationPositive": "Please enter a positive contingent limitation",
            "validUntilAfterValidFrom": "Valid until date must be after valid from date",
            "minimumOrderAmountPositive": "Please enter a positive minimum order amount",
            "discountValueMaxPercentage": "Discount value must not exceed 100% for percentage type",
            "codeMinLength": "The Code needs to have at least 4 letters/chars",
            "formHasErrors": "Please correct the errors in the form before saving"
        },
        "active": {
            "yes": "Yes",
            "no": "No"
        }
    },
    "coupon": {
        "errorNoGarage": "No garage selected. Please select a garage to view coupons.",
        "type": {
            "PERCENTAGE": "Percentage",
            "FIXED_VALUE": "Fixed Amount"
        }
    },
    "customerAnalytics": {
        "title": "Customer Analytics",
        "topProductCategories": "Most clicked product categories",
        "topVehicleModels": "Most clicked vehicle models",
        "topProducts": "Most clicked products",
        "customerLeadsEvents": "User behavior and leads",
        "dailyPlatformUsageRatio": "Platform activity in 30-day trend",
        "events": {
            "visits": "Product Clicked",
            "addedToCart": "Added To Cart",
            "ordered": "Ordered",
            "bookmarked": "Added product to favourites",
            "shared": "Product Shared",
            "enquiries": "Product Enquiry"
        }
    },
    "dashboard": {
        "title": "Dashboard",
        "ecommerce": "E-Commerce",
        "selectBrand": "Select Brand",
        "count": "Count",
        "overview": {
            "title": "Overview",
            "greetings": {
                "morning": "Good morning",
                "afternoon": "Good afternoon",
                "evening": "Good evening"
            },
            "welcome": {
                "title": "Welcome back to your dashboard. Here you can see what is currently happening in your company.",
                "subtitle1": "Here you can get an overview of your key metrics and insights to stay informed about your current performance at all times.",
                "subtitle2": "Find your key metrics and analyses below – stay up to date on your performance at all times.",
                "subtitle3": "Use the following insights and metrics to keep a targeted eye on your performance.",
                "subtitle4": "Here you will find your relevant metrics and insights so that you can make informed decisions based on current data.",
                "subtitle5": "Start with a clear view: Your most important metrics and insights show you where you stand and how you can achieve even more.",
                "subtitle6": "Keep an eye on your successes – the following metrics and analyses will help you to fully exploit your potential.",
                "subtitle7": "Your performance in focus: Use the insights below to make progress visible and to steer the next steps in a targeted manner.",
                "subtitle8": "Those who know their numbers actively shape their success – take a look at your current metrics and insights.",
                "subtitle9": "Keep an eye on your successes – our analyses will help you to fully exploit your potential."
            },
            "widgets": {
                "totalViews": "Monthly Views",
                "avgMonthlyViews": "Avg Monthly Views",
                "trend": "Trend",
                "cartToPurchase": "Conversion Rate (Cart to Purchase)",
                "sales30Days": "Sales (30 Days)",
                "revenue30Days": "Revenue (30 Days)"
            },
            "trends": {
                "up": "Trending up",
                "down": "Trending down",
                "stable": "Stable"
            },
            "subtitles": {
                "last7Days": "Last 7 days: {{count}}",
                "monthlyIncrease": "Monthly change: {{percent}}%",
                "last6MonthsAverage": "Last 6 months average",
                "cartsConverted": "{{purchases}} of {{carts}} carts"
            },
            "chart": {
                "title": "Monthly Views (last 6 Months)",
                "estimation": "Estimation",
                "reality": "Views"
            },
            "loading": "Loading overview data...",
            "error": "Error loading overview data"
        },
        "widgets": {
            "averageCartPrice": "Average Cart Price",
            "averageArticlesInCart": "Average Articles in Cart",
            "totalSoldItems": "Total Sold Items",
            "averageItemsPerPurchase": "Average Items per Purchase",
            "averageCartPriceWithDiscount": "Average Cart Price with Discount",
            "purchasesWithDiscountCodes": "Purchases with Discount Codes",
            "largestSale": "Largest Sale",
            "totalRevenueLastMonth": "Total Revenue Last Month",
            "currentRevenueCurrentMonth": "Current Revenue Current Month",
            "estimatedRevenueCurrentMonth": "Estimated Revenue Current Month",
            "revenueVariation": "{{value}} % compared to the previous month"
        },
        "subtitles": {
            "lastSixMonthsAverage": "Last 6 months average",
            "itemsPerCart": "Items per cart",
            "lastSixMonthsCumulative": "Last 6 months cumulative",
            "itemsPerCompletedPurchase": "Items per completed purchase",
            "whenDiscountCodesApplied": "When discount codes applied",
            "lastSixMonths": "Last 6 months",
            "singleLargestTransaction": "Single largest transaction"
        },
        "charts": {
            "mostSoldItemsTitle": "Most Sold Items - Last 6 Months",
            "clickToFilter": "Click on a product to filter:",
            "noData": "No data available for this product yet.",
            "totalSales": "total sales",
            "numberOfSales": "Number of Sales",
            "numberOfClicks": "Number of Clicks",
            "totalSalesLabel": "Total Sales",
            "totalClicksLabel": "Total Clicks",
            "purchaseTypesDistribution": "Purchase Types Distribution",
            "salesAndRevenue": "Sales and Revenue - Last 6 Months + Current Month",
            "userSources": "User Sources - Where Users Come From",
            "selectUpToThreeSources": "Select up to 3 sources to display:",
            "sources": {
                "qr-mirror": "Mirror Tag",
                "qr-sticker": "Sticker",
                "qr-magnet": "Magnet TAg",
                "google-shopping": "Google Shopping",
                "dealer": "Dealer Website",
                "central": "Central Sales Pages",
                "vehicle-mailing": "Vehicle Mailing",
                "mail-campaign": "Email Campaign",
                "social-media": "Social Media",
                "mobile-app": "Mobile App",
                "unknown": "Without Specification"
            },
            "clearAll": "Clear All",
            "total": "Total",
            "revenue": "Revenue",
            "salesCount": "Sales Count",
            "totalRevenue": "Total Revenue",
            "estimatedRevenue": "Estimated Revenue",
            "estimatedSalesCount": "Estimated Sales Count",
            "revenueShort": "revenue",
            "salesCountShort": "sales count",
            "soFar": "so far",
            "projected": "projected",
            "selected": "Selected",
            "showingOnlyTotal": "showing only total"
        },
        "productSettings": "Product Settings",
        "productPricing": "Product Pricing",
        "categories": {
            "UNDERMOST": "Strongly Below MSRP",
            "UNDER": "Light Under MSRP",
            "EQUAL": "Equals MSRP",
            "OVER": "Light Above MSRP",
            "OVERMOST": "Strongly Above MSRP"
        },
        "options": {
            "shipping": "Shipping",
            "pickup": "Pickup",
            "mounting": "Mounting",
            "mount": "Mounting",
            "notForSale": "Not for Sale",
            "mixed": "Mixed"
        },
        "storefrontAvailable": "Product Availability",
        "storefrontWarnings": "Warnings",
        "warnings": {
            "CHECK_ACTIVATIONS": "Too few products (<90%) are published.",
            "CHECK_DISTRIBUTION_CHANNEL": "Distribution channels are not fully activated for too many products (>20%).",
            "USE_GOOGLE_SHOPPING": "Google Shopping is not configured.",
            "CHECK_GOOGLE_SHOPPING": "Too few products (<10%) are published to Google Shopping.",
            "CHECK_BARGAIN_ACTIVATIONS": "Too few products have a discounted price."
        },
        "noData": {
            "title": "There is no data for this view yet.",
            "hint": "Reports appear once visitors use your shops. New garages see nothing here during their first days."
        },
        "noPermission": "Your role lacks the right to see the dashboard.",
        "contact": {
            "title": "IT-Tecture Support",
            "phone": "+49 (0)381 666989-100",
            "openings": "Mon–Fri 9:00–17:00",
            "helpCenter": "Go to the help center"
        },
        "recommendationsOk": {
            "title": "Very good",
            "text": "You are using the full potential: the products are activated, have favorable prices and various sales options are offered."
        },
        "modules": {
            "WEB": "Homepage module",
            "UCL": "UCL",
            "POS": "Point of sale",
            "unknown": "Unknown"
        }
    },
    "help": {
        "section": {
            "documents": "Documents",
            "faq": "FAQ",
            "contact": "Contact",
            "videos": "Videos"
        },
        "center": {
            "title": "Help Center",
            "description": "Welcome to our Help Center. Find the assistance you need from the sections below.",
            "sections": {
                "documents": {
                    "title": "Documents",
                    "description": "Find all relevant documentation and guides"
                },
                "videos": {
                    "title": "Videos",
                    "description": "Watch helpful tutorial videos and demonstrations"
                },
                "faq": {
                    "title": "FAQ",
                    "description": "Get answers to frequently asked questions"
                },
                "enquiry": {
                    "title": "Support Enquiry",
                    "description": "Submit your questions to our support team"
                }
            }
        },
        "enquiry": {
            "success": "Your enquiry has been successfully submitted. We will get back to you as soon as possible.",
            "confirmationTitle": "Thank you for your enquiry!",
            "error": "There was an error submitting your enquiry.",
            "formTitle": "Contact Form",
            "description": "Welcome to the Support Enquiry section. Please fill out the form below and our team will get back to you.",
            "fields": {
                "subject": {
                    "label": "Subject",
                    "required": "Subject is required"
                },
                "phone": {
                    "label": "Call back number",
                    "required": "Call back number is required"
                },
                "message": {
                    "label": "Message",
                    "required": "Message is required"
                }
            },
            "submit": "Submit enquiry",
            "submitting": "Submitting enquiry …"
        },
        "faq": {
            "heading": {
                "web-module": "Web Module & Web Shop",
                "qr": "QR-Codes",
                "management": "Product Management & Catalogues",
                "google": "Google Shopping"
            },
            "question": {
                "web-module-1": "What do I have to do to integrate the web module or the web shop on my site?",
                "web-module-2": "Do I always have to add a new module to my website when I make changes?",
                "web-module-3": "I use a CMS (e.g. Wordpress) to create my website. Does the Accessory Navigator also work with it?",
                "web-module-4": "How should URLs look like so that they are correctly counted in the dashboard \"User Origin / Sales Channels\"?",
                "qr-1": "Where do the QR codes lead?",
                "qr-2": "Where can I reorder QR code magnet tags?",
                "qr-3": "Can I have the QR code mirror tag printed myself?",
                "qr-4": "Can I use the QR code from the mirror tag elsewhere?",
                "management-1": "Are price adjustments possible for the accessories?",
                "management-2": "What happens when product prices change?",
                "management-3": "What happens if items are no longer available?",
                "management-4": "How can I measure my success?",
                "management-5": "How do I change my hourly labor rate?",
                "google-1": "What is Google Shopping?",
                "google-2": "Why does this format work so well?",
                "google-3": "What are the benefits of Google Shopping?",
                "google-4": "How does Google Shopping work for the Accessory Navigator?",
                "google-5": "How can I participate in Google Shopping?"
            },
            "answer": {
                "web-module-1": "Our web module and the web shop can be easily embedded on any website with the help of an Html- and JavaScript code supplied by us. The installation should be easy even for inexperienced users within 15 minutes.",
                "web-module-2": "No, all changes are made in our management application. You only have to integrate it once on your website.",
                "web-module-3": "Yes, the accessory navigator can also be easily integrated into the well-known CMS systems. You can get instructions and help from our support team.",
                "web-module-4": "If you issue URLs e.g. in e-mails or social media, then you must append the following parameter to the URL: https://www.your-website.de/shop?<b>utm_medium=XXXXX</b> where XXXXX here can be e.g. \"mail-campaign\" for a newsletter campaign, \"social-media\" for links from social media platforms or \"dealer\" for links to your dealer website. The complete list of supported parameters can be found in the installation instructions for the web module.",
                "qr-1": "The QR codes are on the magnet and mirror tags and always lead to the Accessory Navigator on your partner website, so that the customer immediately sees your accessory products on their smartphone.\n\nBut there are differences:\n<ul>\n<li>The <b>QR code magnet tags</b> are attached to the vehicle and are therefore model-specific. Only products that fit the respective vehicle are displayed.</li>\n<li>The QR code on the <b>mirror tags</b> is independent of the vehicle model, i.e. all products are shown. It leads directly to the Accessory Navigator website of your dealership. When setting it up, you decide whether it is on your own website or on the manufacturer's site. The QR code is therefore created individually for your site in each case.</li>\n<li>The QR code on the sticker roll is independent of the vehicle model and works like the QR code on the mirror tags.</li>\n</ul>",
                "qr-2": "If the QR code magnet tags from the starter set provided at the start are not sufficient, you can place a repeat order. Either you would like a complete starter set again or individual vehicle model stickers in the desired quantity. Please<a href=\"enquiry\" style=\"text-decoration:underline\" >call us or send us an e-mail.",
                "qr-3": "You can arrange printing yourself at any time using the PDF document for download - in any number of copies and at a print shop of your choice.",
                "qr-4": "It is obvious that you also use the QR code of your Accessory Navigator in other media, for example on your stationery, on invoices or on business cards. This way you can reach even more of your customers. We have already thought of this and offer you the QR code as a high-resolution graphic file for download.",
                "management-1": "Yes, that is even one of the essential advantages of the Accessory Navigator. You have the option of adjusting the product prices at any time...",
                "management-2": "Should there be any adjustments to the MSRP by one of the manufacturers in Germany, we are the first to know. We don't only provide you with the updated MSRP in the catalogs, but can also - if you wish - automatically recalculate your personalized product prices and thus bring them up to date. We use the price rules that you set when you personalized the price (see next question). For you, this means stress-free price maintenance and significantly less effort.",
                "management-3": "If an article is no longer available from a manufacturer (discontinued or inactive), it will be removed from the catalog for the time being...",
                "management-4": "In the management application you can see your success up to date. Our dashboard shows you all important data about your Accessory Navigator. For example: number of visitors, sales, most clicked categories, product settings and much more",
                "management-5": "You can change the labor rate under the menu item \"My Dealership\". You can adjust it individually for each brand at the bottom of the page by clicking on \"Edit\".",
                "google-1": "Google Shopping is explicitly aimed at customers who are ready to buy and are looking for specific products\n\t\tonline. Google has a separate search category for this purpose, where users can look for products. In addition, Google also plays ads parallel to\n\t\tthe search results of a “normal” Google search, as long as it relates to a purchasable product.",
                "google-2": "Google Shopping is aimed exclusively at users who are ready to buy something. The user sees a picture of the item,\n\t\tthe price, a short description and information about shipping at a glance. So Google makes it very easy for them to make purchases and compare products\n\t\tand offers at different online shops without having to click through all the pages. In short, people who search on Google Shopping want to buy something.</entry>\n\t<entry key=\"custom.help.faq.question.google-3\">What are the benefits of Google Shopping?",
                "google-3": "Google Shopping is particularly targeted at potential customers. The users already know exactly what they want.\n\t\tThe wastage with these ads is therefore very low compared to others. Google Shopping ads score with relevance. This leads to excellent conversion rates.\n\t\tThere is practically no administration effort. You have full control over your costs. The use of Google Shopping leads to more website views and higher awareness\n\t\tof your dealership and website.",
                "google-4": "The Accessory Navigator already provides you with a broad and specific product range. We automatically create the\n\t\tads from the products in your Accessory Navigator. You only pay when users click on your ad and are taken to your website. You decide which of your products\n\t\tshould be found on Google Shopping.",
                "google-5": "Please write us a message that you want to use Google Shopping. You will receive all required information from us."
            }
        }
    },
    "settings": {
        "emailTemplates": {
            "description": "Adapt the customer mails of your garage: accent color and header image per brand.",
            "appearance": "Appearance",
            "template": "E-Mail",
            "templateOrder": "Order confirmation",
            "templateEnquiry": "Product enquiry",
            "templateWishlist": "Favourites",
            "templateGarageOrder": "Order received (garage)",
            "templateGarageEnquiry": "Product enquiry (garage)",
            "templateGarageWishlist": "Favourites (garage)",
            "templateRevocationCustomer": "Revocation",
            "templateRevocationCustomerAnonymous": "Revocation without order",
            "templateRevocationGarage": "Revocation (garage)",
            "templateRevocationGarageAnonymous": "Revocation without order (garage)",
            "templateUpcomingHandover": "Mailer vehicle purchase: Anticipation Mail",
            "templatePastHandover": "Mailer vehicle purchase: Final Mail",
            "templateSaleContracted": "Mailer vehicle purchase: Welcome Mail",
            "templateAccountActivation": "Activate account",
            "templateAccountPasswordReset": "Reset password",
            "templateDormantWarning": "Account: inactivity notice",
            "templateDormantInactivation": "Account: deactivation",
            "templateContractSignedCustomer": "Contract signed",
            "templateContractSignedBusiness": "Contract signed (internal)",
            "templateSmtpConfirmation": "Mail server confirmed",
            "templateSmtpTest": "Mail server test mail",
            "templateSmtpFailure": "Mail server unreachable",
            "templateHelpDesk": "Support enquiry (internal)",
            "templateDeadLetter": "Undeliverable mail (internal)",
            "brand": "Brand",
            "accentColor": "Accent color",
            "accentHex": "Colour value",
            "accentPick": "Choose accent color",
            "accentArea": "Saturation and brightness",
            "accentHue": "Hue",
            "accentNoHex": "Please enter a color as a hex value, for example #EC0000.",
            "accentCustom": "custom",
            "uploadHeroImage": "Upload header image",
            "heroImage": "Header image",
            "chooseHeroImage": "Choose image",
            "heroImageActive": "custom image active",
            "heroImageInfo": "The header image is the header image at the top of every customer mail. PNG or JPEG, up to {{warn}} recommended. Images wider than {{scaleWidth}} pixels are scaled down to the mail width automatically.",
            "heroImageInfoLabel": "About the header image",
            "brandSwitchMessage": "You have unsaved changes. Switch the brand anyway?",
            "brandSwitchConfirm": "Switch brand",
            "preview": "Preview",
            "subjectLabel": "Subject",
            "previewHint": "Preview with sample data, displayed just like the actual email. The color and image apply to all customer emails.",
            "previewMailReceiver": "Preview receiver",
            "sendPreviewMail": "Send preview as mail",
            "sendPreviewMailConfirm": "Send",
            "previewMailHint": "Sends the mail chosen in the preview with demo data to this address – with the values set right now, saved or not.",
            "previewMailSent": "Preview sent to {{receiver}}.",
            "previewMailFailed": "The preview could not be sent.",
            "descriptionGroup": "Customize your group's emails. You can customize the accent color and header image for each brand.",
            "accentInherited": "Standard",
            "heroImageChosen": "new image chosen",
            "heroImageInherited": "Standard",
            "loadFailed": "The settings could not be loaded.",
            "saveFailed": "The settings could not be saved.",
            "previewFailed": "The preview could not be displayed.",
            "previewLinkDisabled": "Links don't work in the preview.",
            "imageTypeRejected": "Only PNG and JPEG are possible.",
            "imageTooLarge": "The image is too large, {{max}} at most.",
            "imageLarge": "The image is larger than the recommended {{warn}}. Saving is possible, but it slows down every customer mail.",
            "imagePixelsTooLarge": "At {{width}} × {{height}} pixels the image is too large, {{maxWidth}} × {{maxHeight}} pixels at most.",
            "imageWillBeScaled": "At {{width}} × {{height}} pixels the image is wider than the mail width and is scaled down to {{scaleWidth}} pixels automatically on save.",
            "imageScaled": "The image was scaled down from {{width}} × {{height}} pixels to {{scaleWidth}} pixels wide.",
            "imageUploadTooLarge": "The image could not be uploaded, it is too large.",
            "imageRejected": "The image could not be used. Please choose another image.",
            "previewStale": "The preview is out of date, the last change could not be rendered.",
            "previewRetry": "Reload preview",
            "saveSuccess": "The settings have been saved.",
            "imageStoredTooLarge": "Even scaled down the image is still larger than {{max}}. Please choose another image or save it with stronger compression."
        },
        "mailServer": {
            "host": "SMTP host",
            "port": "Port",
            "encryption": "Encryption",
            "encryptionNone": "None",
            "encryptionStartTlsHint": "STARTTLS still works but is no longer considered secure. Choose SSL/TLS where your server offers it.",
            "encryptionNoneHint": "This setting predates the encryption requirement. Without SSL/TLS or STARTTLS it can no longer be saved – the mails carry personal data of your customers.",
            "username": "User name",
            "password": "Password",
            "passwordUnchanged": "unchanged",
            "senderName": "Sender name",
            "senderAddress": "Sender address",
            "saved": "Settings saved",
            "readOnlyInSupportContext": "In a support context the mail sending is read-only. Only the customer can set it up or change it.",
            "saveFailed": "The settings could not be saved.",
            "loadFailed": "The settings could not be loaded.",
            "discardBack": "Back",
            "discardConfirm": "Discard",
            "discardTitle": "Discard changes",
            "discardConfirmToActive": "This discards all your input and returns to your last saved configuration. Nothing about the sending changes.",
            "discarded": "Changes discarded",
            "discardFailed": "The changes could not be discarded.",
            "removeTitle": "Stop using own mail server",
            "removeConfirm": "Stop using",
            "removeConfirmGarage": "All mails then go out over the standard mail server of the Accessory Navigator again.\nYour settings are deleted irrevocably; to use your own server again you have to set it up anew.",
            "removeConfirmGroup": "Your garages then send over the standard mail server of the Accessory Navigator again, unless they have a mail server of their own. We delete your saved settings and any change that has not been activated yet. This takes effect immediately and can only be undone by setting the server up again.",
            "removed": "We no longer send over your mail server.",
            "removeFailed": "Your mail server settings could not be deleted.",
            "retry": "Try again",
            "retryFailed": "The new attempt could not be started.",
            "activationReceiver": "Send code to",
            "sendActivationMail": "Send code",
            "resendActivationMail": "Request a new code",
            "resendActivationMailIn": "New code in {{seconds}} s",
            "resendWait": "Please wait {{seconds}} s",
            "activationMailSent": "Code sent",
            "activationMailFailed": "The code could not be sent.",
            "saveReplacesCode": "Please save your changes. Then request a new code – the one from the previous mail will no longer work.",
            "activationCode": "Activation code",
            "activate": "Activate",
            "activationFailed": "The activation failed.",
            "activationActivated": "Mail server activated",
            "activationNoCandidate": "There is no pending change to activate.",
            "activationInvalidCode": "The code entered is not correct.",
            "activationExpired": "The code has expired. Please send a new one.",
            "activationTooManyAttempts": "Too many failed attempts. Please send a new code.",
            "remainingAttempts": "Remaining attempts: {{count}}",
            "bannerFailing": "Your mail server may not be reachable. Please review your mail settings.",
            "bannerDeactivated": "Your mail server cannot be reached! Please review your mail settings!",
            "bannerAction": "Check",
            "attentionRequired": "Mail sending needs your attention",
            "failureFromCheck": "regular check",
            "failureFromTestMail": "test mail",
            "failureFromSend": "sending a customer mail",
            "testMail": "Test mail",
            "testMailHelp": "You can send a test mail over your active mail server at any time, for example after something changed in your IT. This does not change your configuration.",
            "testMailReceiver": "Send test mail to",
            "sendTestMail": "Send test mail",
            "testMailSent": "Test mail sent",
            "testMailFailed": "The test mail could not be sent.",
            "statusReasonNone": "Nothing unusual.",
            "rejectedNeedsUsername": "Please enter the user name the mail server logs in with.",
            "rejectedNeedsPassword": "Please enter the password – a first setup has none to carry over.",
            "rejectedNeedsEncryption": "A mail server without transport encryption is not saved. Please choose SSL/TLS or STARTTLS.",
            "rejectedNothingToRetry": "Sending over your mail server is not paused, so there is nothing to check again.",
            "rejectedNoCandidate": "There is no pending change. Please save your settings again.",
            "rejectedNoVerifiedServer": "You currently have no own mail server in use that could be tested.",
            "rejectedNoSendingServer": "No mail server is available to send this mail over.",
            "statusReasonAuth": "The server refused the user name or the password.",
            "statusReasonMessaging": "The server could not be reached under the configured host and port.",
            "statusReasonOther": "The connection failed for an unexpected reason.",
            "routesIntro": "Choose how you want to send emails to your customers.",
            "fallbackPlatform": "Standard mail server",
            "fallbackGroup": "Your group's mail server",
            "sendingVia": "Sent via:",
            "ownServerOffer": "Mails to your customers come from your own address.",
            "pillActive": "Active",
            "pillActiveUntilCode": "Still active – until your own mail server is set up",
            "pillActiveUntilRepaired": "Active until your server works again",
            "pillStandby": "Steps in on errors",
            "pillWaitingForCode": "Waiting for the code",
            "pillCodeSent": "Code sent",
            "pillActivePrevious": "Active with the previous settings",
            "pillChangeWaiting": "Change waiting for the code",
            "pillFailing": "{{count}} of {{of}} attempts failed",
            "pillDeactivated": "Switched off",
            "failingDetail": "{{reason}} We keep sending over your mail server. If {{of}} attempts (check or sending) fail in a row, we send over the standard mail server; no mail is lost.",
            "deactivatedDetail": "{{of}} attempts in a row failed. {{reason}} Meanwhile, mails to your customers go out over the standard mail server; no mail is lost.",
            "deactivatedAtOnce": "While sending a customer mail, your server reported a fault. {{reason}} Meanwhile, mails to your customers go out over the standard mail server; no mail is lost.",
            "newSettings": "New: {{line}}",
            "setUp": "Set up",
            "enterCode": "Enter code",
            "edit": "Edit",
            "checkSettings": "Check settings",
            "useFallbackPlatform": "Use the standard mail server",
            "useFallbackGroup": "Use your group's mail server",
            "discardChange": "Discard change",
            "cancelSetupTitle": "Cancel the setup",
            "cancelSetupMessage": "We delete the settings you saved for your own mail server, and a code already sent expires. Mails to your customers keep going out as before. To send over your own mail server later, set it up again.",
            "cancelSetupConfirm": "Delete settings",
            "setupCancelled": "Setup cancelled",
            "stepSettings": "Settings",
            "stepSendCode": "Send code",
            "stepEnterCode": "Enter code",
            "saveAndContinue": "Save and continue",
            "continue": "Continue",
            "back": "Back",
            "sendCodeHelp": "We send a numeric code over the settings you have just saved. If it arrives, your mail server works. Until then, sending stays as it is.",
            "enterCodeHelp": "Enter the code from the mail to {{receiver}}. It is valid for {{hours}} hours. If you change the settings again first, you need a new code.",
            "enterCodeHelpNoReceiver": "Enter the code from the mail we sent you. It is valid for {{hours}} hours. If you change the settings again first, you need a new code.",
            "noMailReceived": "No mail received?",
            "doneText": "Your mail server is active. From now on, mails to your customers come from {{sender}}.",
            "doneCheck": "We check it every night. If a check fails, you will see it here and across the cockpit.",
            "dialogDiscardTitle": "Discard your input?",
            "dialogDiscardMessage": "Your input has not been saved yet and is lost when you close the dialog.",
            "dialogKeepEditing": "Keep editing",
            "showTechnicalDetails": "Show technical details",
            "hideTechnicalDetails": "Hide technical details",
            "transport": "Send over",
            "transportSmtp": "Own SMTP server",
            "transportOffice365": "Microsoft 365",
            "tenantId": "Directory (tenant) ID",
            "clientId": "Application (client) ID",
            "clientSecret": "Client secret",
            "clientSecretHint": "The value of the secret, not its secret ID",
            "secretUnchanged": "Stored – enter again to change",
            "mailbox": "Mailbox",
            "senderNameFromExchange": "Microsoft 365 sets the sender name itself.",
            "office365Intro": "These values come from an app registration in your Microsoft Entra directory.",
            "correctSettings": "Correct the settings",
            "statusReasonMailTooLarge": "The mail was too large to send.",
            "statusReasonSecretExpired": "The client secret has expired. Create a new one in Microsoft Entra and enter it here.",
            "statusReasonSecretInvalid": "The client secret was not accepted. Enter the value of the secret, not its secret ID.",
            "statusReasonAppNotFound": "The application ID is unknown in this directory.",
            "statusReasonTenantNotFound": "The directory ID is unknown.",
            "statusReasonAccessDenied": "The application may not send from this mailbox. Check the permission in Microsoft 365.",
            "statusReasonMailboxNotFound": "The mailbox was not found.",
            "rejectedNeedsHost": "Please enter the server.",
            "rejectedNeedsPort": "Please enter the port.",
            "rejectedNeedsTenantId": "Please enter the directory ID.",
            "rejectedInvalidTenantId": "The directory ID must be a GUID or a verified domain.",
            "rejectedNeedsClientId": "Please enter the application ID.",
            "rejectedNeedsClientSecret": "Please enter the client secret.",
            "office365Offer": "Send over your own Microsoft 365."
        }
    },
    "priceBook": {
        "title": "Price book",
        "overview": {
            "title": "Price books",
            "description": "All price books of contract management with their bands, plus the hardware and one-off prices they share. Changes apply to new offers; offers and contracts already calculated keep their prices.",
            "noTiers": "No bands are configured for this price book.",
            "edit": "Edit price book"
        },
        "locations": "Locations",
        "notFound": "This price book was not found.",
        "saveSuccess": "The prices have been saved.",
        "saveError": "The prices could not be saved.",
        "groups": {
            "tariff": "Tariff per location / month (€)",
            "modules": "Add-on modules per location / month (€)",
            "setup": "Setup per location / one-off (€)"
        },
        "fees": {
            "basisFee": "Basis",
            "standardFee": "Standard",
            "premiumFee": "Shop",
            "additionalBrandFee": "Brand­surcharge",
            "vehicleExchangeModuleFee": "Vehicle­exchange",
            "groupModuleFee": "Group­module",
            "basisSetupCost": "Basis",
            "standardSetupCost": "Standard",
            "premiumSetupCost": "Shop"
        },
        "setupFees": {
            "title": "Hardware and one-off prices",
            "tablet": "Tablet",
            "tabletTerminal": "Stand for Tablet",
            "qrHanger": "QR Mirror Hanger",
            "qrCodes": "QR Magnet Tag (set)",
            "qrStickerRoll": "QR Sticker Roll",
            "edit": "Edit prices"
        },
        "addBand": "Add band",
        "removeBand": "Remove band",
        "minLocations": "Locations from",
        "maxLocations": "Locations up to",
        "issues": {
            "label": "Note on the bands",
            "summary": "There are gaps and/or overlaps in the location definition. Affected rows are marked; saving is still possible.",
            "inverted": "The upper bound is below the lower one.",
            "overlap": "Overlaps the preceding band.",
            "gap": "Gap to the preceding band - the location counts in between have no price.",
            "activeWithoutBands": "This price book is active but has no bands. It is offered when an offer is calculated, but the calculation will fail there. Add bands or deactivate the price book."
        },
        "displayName": "Display name",
        "internalName": "Internal name",
        "internalNameHint": "Key used by the price calculation, must be unique.",
        "properties": "Properties",
        "active": "Price book is active",
        "activeHint": "An inactive price book is no longer offered when an offer is calculated. Existing offers and contracts are unaffected.",
        "inactive": "inactive",
        "create": {
            "title": "Create price book",
            "submit": "Create price book",
            "copyFrom": "Copy bands from",
            "copyFromHint": "Optional. The bands of the chosen price book are copied and can be adjusted afterwards.",
            "noTemplate": "No template - start empty",
            "success": "The price book has been created.",
            "error": "The price book could not be created."
        },
        "delete": {
            "title": "Delete price book",
            "submit": "Delete price book",
            "confirm": "Delete the price book “{{label}}” for good? Its bands go with it. This cannot be undone.",
            "success": "The price book has been deleted.",
            "inUse": "This price book has already been used for offers and therefore cannot be deleted. Deactivate it instead.",
            "error": "The price book could not be deleted."
        }
    },
    "supportContext": {
        "searchLabel": "Work in context",
        "searchPlaceholder": "Search garage or group",
        "garage": "garage",
        "group": "group",
        "noOptions": "No matches",
        "loading": "Searching …",
        "banner": "You are working in the context of {{type}} “{{label}}”.",
        "bannerHint": "You see the cockpit from the customer's point of view, with your own permissions. Contracts are locked, the data processing agreement and the mail sending are read-only; access to orders is logged.",
        "end": "Leave",
        "orderAccess": {
            "title": "Access to orders",
            "text": "Orders hold customer data of “{{label}}”. Your access is logged with your user account. Only open orders when a support request requires it.",
            "confirm": "Log access and open"
        }
    },
    "garageGroupList": {
        "menu": "Groups",
        "title": "Groups",
        "search": "Name or customer number",
        "customerNumber": "Customer no.",
        "name": "Group",
        "empty": "No groups found"
    },
    "supportStart": {
        "menu": "Start",
        "title": "Support start",
        "search": {
            "title": "Work in the context of a customer",
            "description": "Search by name or customer number of a garage or group. For a garage, its group is suggested as well."
        },
        "recent": {
            "title": "Recently used",
            "empty": "The garages and groups you last worked for will appear here."
        },
        "quickAccess": {
            "title": "Quick access"
        },
        "howItWorks": {
            "title": "How the context works",
            "view": "You see the cockpit from the customer's point of view – with your own permissions, without signing in as the customer.",
            "write": "You can edit products and prices, master data, users, discount codes and the mailer; every change is logged with your user account.",
            "blocked": "Contracts, signing the data processing agreement, the mail server, help center enquiries and your own account are locked in a context. You handle orders like the garage; every access to them is logged.",
            "end": "The context applies to this tab only and ends with “Leave” in the yellow banner or when you sign out."
        }
    }
}
